import ActionCardGridView from "@/components/actions/ActionCardGridView";
import { useFeatureName } from "@/hooks/useFeatureName";
import type { LayoutContext } from "@/lib/models";
import { featureCreateActionUrlBuilder } from "@/lib/url-builder";
import { Action, ActionService } from "@/services/ActionService";
import { useEffect, useState } from "react";
import { useOutletContext, useParams } from "react-router";

const FeatureActionListPage: React.FC = () => {
  const params = useParams();
  const { setPageName } = useOutletContext<LayoutContext>();
  const [actionsList, setActionsList] = useState<Action[]>([]);
  const { featureName, } = useFeatureName(params.featureId!);

  useEffect(() => {
    const initializeActions = async () => {
      const actions = await ActionService.getByFeatureId(params.featureId!);
      setActionsList(actions);
    };
    initializeActions();
  }, [params.featureId]);

  useEffect(() => {
    setPageName("Tasks List");
    return () => setPageName("Tasks List"); // Optional: Reset on unmount
  }, [setPageName]);

  return (
    <div className="container mx-auto p-4">
      <ActionCardGridView actionsList={actionsList} title={`Feature: ${featureName}`} createUrl={featureCreateActionUrlBuilder(params.tenantId!, params.siteId!, params.featureId!)} />
    </div>
  );
};

export default FeatureActionListPage;
